import { getApiBaseUrl } from './apiBase';
const API_BASE_URL = getApiBaseUrl();

export const uploadService = {
  async listPublic() {
    const res = await fetch(`${API_BASE_URL}/uploads/public`);
    const data = await res.json();
    if (!res.ok) throw new Error(data.msg || 'Failed to list public uploads');
    return data.uploads || [];
  },
  async list() {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('No authentication token found');
    const res = await fetch(`${API_BASE_URL}/uploads`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.msg || 'Failed to list uploads');
    return data.uploads || [];
  },

  async get(id) {
    const res = await fetch(`${API_BASE_URL}/uploads/${encodeURIComponent(id)}`);
    const data = await res.json();
    if (!res.ok) throw new Error(data.msg || 'Failed to fetch upload');
    return data.upload;
  },

  async create(payload) {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('No authentication token found');
    const res = await fetch(`${API_BASE_URL}/uploads`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.msg || 'Failed to create upload');
    return data.upload;
  },

  async createPublic(payload) {
    const res = await fetch(`${API_BASE_URL}/uploads/public`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.msg || 'Failed to submit upload');
    return data.upload;
  },

  async remove(id) {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('No authentication token found');
    const res = await fetch(`${API_BASE_URL}/uploads/${encodeURIComponent(id)}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.msg || 'Failed to delete upload');
    return data;
  }
  ,

  async update(id, updates) {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('No authentication token found');
    const res = await fetch(`${API_BASE_URL}/uploads/${encodeURIComponent(id)}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(updates)
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.msg || 'Failed to update upload');
    return data.upload;
  }
};